import apiClient from "services/apiClient";

async function manageDomainPropagation(id: any, status:string): Promise<any> {
    const res = await apiClient.put(`/admin/brands/${id}/dns-propagation?status=${status}`);
    return res.data;
}

export default manageDomainPropagation;